import { modelRoutes, type TersaImageModel } from '../../types';
import { providers } from '../../../providers';
import { kie } from '../../kie';
import { suchuang } from '../../suchuang';
import { wavespeed } from '../../wavespeed';
import { grsai } from '../../grsai';
import { baidu } from '../../baidu';

// 系数
const COST_FACTOR = 1.0;

export const nanoBananaModels: Record<string, TersaImageModel> = {
    'nano-banana-2-lite': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: undefined,
                model_create: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': kie.image('nano-banana-2-lite'),
                        other: suchuang.image('nano-banana-2-lite'),
                    },
                }, kie.image('nano-banana-2-lite')),
                modelBackup_create: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': [kie.image('nano-banana-2-lite'), wavespeed.image('nano-banana-2-lite/text-to-image')],
                        other: [kie.image('nano-banana-2-lite'), wavespeed.image('nano-banana-2-lite/text-to-image')],
                    },
                }, [kie.image('nano-banana-2-lite'), wavespeed.image('nano-banana-2-lite/text-to-image')]),
                model_edit: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': kie.image('nano-banana-2-lite'),
                        other: suchuang.image('nano-banana-2-lite'),
                    },
                }, kie.image('nano-banana-2-lite')),
                modelBackup_edit: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': [kie.image('nano-banana-2-lite'), wavespeed.image('nano-banana-2-lite/edit')],
                        other: [kie.image('nano-banana-2-lite'), wavespeed.image('nano-banana-2-lite/edit')],
                    },
                }, [kie.image('nano-banana-2-lite'), wavespeed.image('nano-banana-2-lite/edit')]),
                getCost: () => {
                    return 0.0343 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.0343 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '30MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'nano-banana-2-fast': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: undefined,
                model_create: wavespeed.image('nano-banana-2/text-to-image-fast'),
                modelBackup_create: [kie.image('nano-banana-2'), baidu.image('nano-banana-2'), wavespeed.image('nano-banana-2/text-to-image')],
                model_edit: wavespeed.image('nano-banana-2/edit-fast'),
                modelBackup_edit: [kie.image('nano-banana-2'), baidu.image('nano-banana-2'), wavespeed.image('nano-banana-2/edit')],
                getCost: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '2K';
                    if (resolution === '2K') return 0.045 * COST_FACTOR;
                    if (resolution === '4K') return 0.05 * COST_FACTOR;
                    return 0.05 * COST_FACTOR;
                },
                getPassCount: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '2K';
                    if (resolution === '2K') return 0.045 * 100 * COST_FACTOR;
                    if (resolution === '4K') return 0.05 * 100 * COST_FACTOR;
                    return 0.05 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['2K', '4K'],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 14, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        plugin: ['camera'],
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
    'nano-banana-2-1': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: undefined,
                model_create: grsai.image('nano-banana-2-1'),
                modelBackup_create: [suchuang.image('nano-banana-2.1'), kie.image('nano-banana-2-1')],
                model_edit: grsai.image('nano-banana-2-1'),
                modelBackup_edit: [suchuang.image('nano-banana-2.1'), kie.image('nano-banana-2-1')],
                getCost: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
                    if (resolution === '1K') return 0.07 * COST_FACTOR;
                    if (resolution === '2K') return 0.105 * COST_FACTOR;
                    if (resolution === '4K') return 0.14 * COST_FACTOR;
                    return 0.14 * COST_FACTOR;
                },
                getPassCount: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
                    if (resolution === '1K') return 0.07 * 100 * COST_FACTOR;
                    if (resolution === '2K') return 0.105 * 100 * COST_FACTOR;
                    if (resolution === '4K') return 0.14 * 100 * COST_FACTOR;
                    return 0.14 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 14, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
        plugin: ['camera'],
    },
    'nano-banana-2': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: undefined,
                model_create: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': grsai.image('nano-banana-2'),
                        other: suchuang.image('nano-banana-2'),
                    },
                }, kie.image('nano-banana-2')),
                modelBackup_create: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': [kie.image('nano-banana-2'), baidu.image('nano-banana-2'), wavespeed.image('nano-banana-2/text-to-image')],
                        other: [kie.image('nano-banana-2'), grsai.image('nano-banana-2'),baidu.image('nano-banana-2'), wavespeed.image('nano-banana-2/text-to-image')],
                    },
                }, [wavespeed.image('nano-banana-2/text-to-image')]),
                model_edit: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': grsai.image('nano-banana-2'),
                        other: suchuang.image('nano-banana-2'),
                    },
                }, kie.image('nano-banana-2')),
                modelBackup_edit: modelRoutes({
                    other: {
                        '1x4,4x1,1x8,8x1': [kie.image('nano-banana-2'), baidu.image('nano-banana-2'), wavespeed.image('nano-banana-2/edit')],
                        other: [kie.image('nano-banana-2'), grsai.image('nano-banana-2'), baidu.image('nano-banana-2'), wavespeed.image('nano-banana-2/edit')],
                    },
                }, [wavespeed.image('nano-banana-2/edit')]),
                getCost: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
                    if (resolution === '1K') return 0.07 * COST_FACTOR;
                    if (resolution === '2K') return 0.105 * COST_FACTOR;
                    if (resolution === '4K') return 0.14 * COST_FACTOR;
                    return 0.14 * COST_FACTOR;
                },
                getPassCount: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
                    if (resolution === '1K') return 0.07 * 100 * COST_FACTOR;
                    if (resolution === '2K') return 0.105 * 100 * COST_FACTOR;
                    if (resolution === '4K') return 0.14 * 100 * COST_FACTOR;
                    return 0.14 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '8x1', '1x8', '5x4', '4x5', '4x1', '1x4', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 14, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
        // 插件
        plugin: ['camera'],
    },
    'nano-banana-pro': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: undefined,
                model_create: kie.image('nano-banana-pro'),
                modelBackup_create: [grsai.image('nano-banana-pro'), baidu.image('nano-banana-pro'), wavespeed.image('nano-banana-pro/text-to-image')],
                model_edit: kie.image('nano-banana-pro'),
                modelBackup_edit: [grsai.image('nano-banana-pro'), baidu.image('nano-banana-pro'), wavespeed.image('nano-banana-pro/edit')],
                getCost: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
                    if (resolution === '1K') return 0.10 * COST_FACTOR;
                    if (resolution === '2K') return 0.14 * COST_FACTOR;
                    if (resolution === '4K') return 0.24 * COST_FACTOR;
                    return 0.24 * COST_FACTOR;
                },
                getPassCount: ({ providerOptions } = {}) => {
                    const resolution = typeof providerOptions?.image_resolution === 'string' ? providerOptions.image_resolution.toUpperCase() : '1K';
                    if (resolution === '1K') return 0.10 * 100 * COST_FACTOR;
                    if (resolution === '2K') return 0.14 * 100 * COST_FACTOR;
                    if (resolution === '4K') return 0.24 * 100 * COST_FACTOR;
                    return 0.24 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: ['1K', '2K', '4K'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 14, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
        // 插件
        plugin: ['camera'],
    },
    'nano-banana': {
        chef: providers.google,
        providers: [
            {
                ...providers.google,
                model: undefined,
                model_create: kie.image('nano-banana'),
                modelBackup_create: [grsai.image('nano-banana'), baidu.image('nano-banana'), wavespeed.image('nano-banana/text-to-image')],
                model_edit: kie.image('nano-banana'),
                modelBackup_edit: [grsai.image('nano-banana'), baidu.image('nano-banana'), wavespeed.image('nano-banana/edit')],
                getCost: () => {
                    return 0.038 * COST_FACTOR;
                },
                getPassCount: () => {
                    return 0.038 * 100 * COST_FACTOR;
                },
            },
        ],
        configByMode: {
            t2i: {
                sizes: ['21x9', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
            },
            i2i: {
                sizes: ['match', '21x9', '16x9', '9x16', '5x4', '4x5', '4x3', '3x4', '3x2', '2x3', '1x1'],
                resolutions: [],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 14, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                },
            },
        },
        precheckByMode: {
            t2i: ['prompt'],
            i2i: ['prompt', 'image'],
        },
        imagesCountOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        supportsInput: ['t2i', 'i2i'],
        supportsEdit: true,
        supportsImageType: 'url',
        priceIndicator: 'lowest',
        price: 'Dynamic',
    },
};